export const driverPublicForm = {
    driverCode: '',
    driverName: '',
    phoneNo: '',
    idCard: '',
    familyAddress: '',
    driverStatus: '',
    drivingLicence: '',
    blackFlag: '',
    identificationFlag: '',
    countryCode: '',
    countryName: '',
    provinceCode: '',
    provinceName: '',
    cityCode: '',
    cityName: '',
    district: '',
    idCardFileId: '',
    idCardFileName: '',
    idCardFileUrl: '',
    idCardEndDate: '',
    idCardBottomSideFileName: '', // 身份证国徽面
    idCardBottomSideFileUrl: '', //
    idCardBottomSideFileId: '', //
    idCardStartDate: '', //
    driveType: '', // 准驾车型
    drivingLicenceFileId: '',
    drivingLicenceFileName: '',
    drivingLicenceFileUrl: '',
    driveEndDate: '',
    onWayContactCategory: '', // 在途联系类别
    onWayContactName: '', // 在途联系人
    onWayContactPhone: '', // 在途联系人电话
    driveStartDate: '', // 驾驶证起始日期
    delegateFileId: '', // 委派函文件id
    delegateFileName: '', // 委派函文件名称
    delegateFileUrl: '', // 委派函文件url
    delegateStartTime: '', // 委派函起始日期
    delegateEndTime: '', // 委派函结束日期
    pushType: '', // 签署方式
    birthday: '', // 出生日期(身份证)
    people: '', // 民族(身份证)
    authorityIssue: '', // 签发机关(身份证)
    mainNationality: '', // 国籍(驾驶证)
    dateIssue: '', // 初次领证日期(驾驶证)
    empCertificate: '', // 从业资格证号
    empCertificateFileId: '', // 从业资格证id
    empCertificateFileName: '', // 从业资格证名称
    empCertificateFileUrl: '', // 从业资格证url
    empCertificateEndDate: '', // 从业资格证到期日期
    driverLicenseAuthority: '', // 签发机关（驾驶证）
    stamperName: '', // 签署人名称
    stamperCode: '', // 签署人编码
    stamperMobile: '', // 签署人手机号码
    delegateOnline: '', // 委派函类型(0 == 线下  1 == 线上)
    empCertificateType: '', // 从业资格类别
}

export const idCardBringOutFieldsConfig = [
    { field: 'driverName', type: 'text' },
    { field: 'idCard', type: 'text' },
    { field: 'familyAddress', type: 'text' },
    { field: 'birthday', type: 'date' },
    { field: 'people', type: 'text' },
    { field: 'empCertificate', type: 'text' },
    { field: 'empCertificateFileId', type: 'text' },
    { field: 'empCertificateFileName', type: 'text' },
    { field: 'empCertificateFileUrl', type: 'text' },
    // { field: 'phoneNo', type: 'text' },
]
